<template>
  <div class="app-container">
    <el-card style="margin-bottom: 10px">
      <el-form
        ref="form" :model="queryForm" label-position="top"
        size="small"
      >
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item>
              <template slot="label">
                <div class="selectLabel">
                  <el-select
                    v-model="selectType"
                    :placeholder="$t('orderDetails.pleaseChoose')"
                    style="width: 180px"
                  >
                    <!--                   客户单号 -->
                    <el-option key="3" :label="$t('placeOrder.customerNumber')" :value="3" />
                    <!--运单号-->
                    <el-option key="1" :label="$t('newOrder.waybillNumber')" :value="1" />
                    <!--               扫描单号     -->
                    <el-option key="2" :label="$t('placeOrder.scanOrderNumber')" :value="2" />
                    <!-- NFe秘钥 -->
                    <el-option key="4" :value="4" label="NFe秘钥" />
                  </el-select>
                </div>
              </template>
              <el-input
                v-model="queryForm.params.inputValue"
                :placeholder="$t('newOrder.PreciseSearch1')"
                :rows="1"
                clearable
                style="width: 100%"
                type="textarea"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('collectionCenter.pushTime')">
              <!--查询时间-->
              <el-date-picker
                v-model="timeValue"
                :default-time="['00:00:00', '23:59:59']"
                :end-placeholder="$t('operationCenter.endDate')"
                :start-placeholder="$t('operationCenter.startDate')"
                range-separator="~"
                style="width: 100%"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                @change="dateChange"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!--客户-->
            <el-form-item :label="$t('receivablePayable.customer')">
              <el-select
                v-model="queryForm.params.customerId"
                :placeholder="$t('spareNumberPoo.Only10AreDisplayed')"
                :remote-method="getCustomerPage"
                clearable
                filterable
                remote
                reserve-keyword
                style="width: 100%"
                @focus="getCustomerPage()"
              >
                <el-option
                  v-for="(item, ind) in customerList"
                  :key="ind"
                  :label="item.customerAlias + '(' + item.username + ')'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <!--是否成功-->
            <el-form-item :label="$t('orderCenterCont.WhetherSuccessful')" name="customerId">
              <el-select v-model="queryForm.params.state" style="width: 100%">
                <el-option :label="$t('GlobalSetObj.all')" :value="null" />
                <el-option :label="$t('GlobalSetObj.succeed')" :value="1" />
                <el-option :label="$t('GlobalSetObj.Lose')" :value="0" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-button
        icon="el-icon-search" size="small" type="primary"
        @click="searchResources(1)"
      >{{ $t('operationCenter.Procurar') }}
      </el-button>
      <el-button icon="el-icon-refresh-left" size="small" @click="searchResources(2)">
        {{ $t('operationCenter.reset') }}
      </el-button>
      <el-button size="small" @click="allExportOrder">
        {{ $t('operationCenter.exports') }}
      </el-button>
    </el-card>
    <el-card>
      <el-table :data="tableData" border>
        <!--序号-->
        <el-table-column :label="$t('operationCenter.ind')" align="center" width="60px">
          <template slot-scope="scope">
            <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <!--  推送时间 -->
        <el-table-column :label="$t('collectionCenter.pushTime')" min-width="170" prop="pushTime" />
        <!--客户-->
        <el-table-column
          :label="$t('operationCenter.client')"
          :show-overflow-tooltip="true"
          align="left"
          min-width="180"
          prop="customerName"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.customerName }}</div>
          </template>
        </el-table-column>
        <!--客户单号-->
        <el-table-column
          :label="$t('placeOrder.customerNumber')"
          :show-overflow-tooltip="true"
          align="left"
          min-width="180"
          prop="customerNumber"
        >
          <template slot-scope="scope">
            <div>
              <el-popover placement="top" popper-class="copy" trigger="hover">
                <el-button
                  style="color: black; font-size: 12px; padding: 2px"
                  type="text"
                  @click="copy(scope.row.customerNumber)"
                >
                  {{ $t('orderDetails.copy') }}
                </el-button>
                <div slot="reference" class="is-click-column" @click="operationBtn(scope.row)">
                  {{ scope.row.customerNumber }}
                </div>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <!--运单号-->
        <el-table-column
          :label="$t('newOrder.waybillNumber')"
          :show-overflow-tooltip="true"
          align="left"
          min-width="180"
          prop="waybillNumber"
        >
          <template slot-scope="scope">
            <div>
              <el-popover placement="top" popper-class="copy" trigger="hover">
                <el-button
                  style="color: black; font-size: 12px; padding: 2px"
                  type="text"
                  @click="copy(scope.row.waybillNumber)"
                >
                  {{ $t('orderDetails.copy') }}
                </el-button>
                <div slot="reference">
                  {{ scope.row.waybillNumber }}
                </div>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <!--扫描单号-->
        <el-table-column
          :label="$t('placeOrder.scanOrderNumber')"
          :show-overflow-tooltip="true"
          align="left"
          min-width="180"
          prop="scanOrderNumber"
        >
          <template slot-scope="scope">
            <div>
              <el-popover placement="top" popper-class="copy" trigger="hover">
                <el-button
                  style="color: black; font-size: 12px; padding: 2px"
                  type="text"
                  @click="copy(scope.row.scanOrderNumber)"
                >
                  {{ $t('orderDetails.copy') }}
                </el-button>
                <div slot="reference">
                  {{ scope.row.scanOrderNumber }}
                </div>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <!-- NFe密钥 -->
        <el-table-column :label="$t('tablePrice.nfeKey')" min-width="180" prop="nfeKey">
          <template slot-scope="scope">
            <div>
              <el-popover placement="top" popper-class="copy" trigger="hover">
                <el-button
                  style="color: black; font-size: 12px; padding: 2px"
                  type="text"
                  @click="copy(scope.row.nfeKey)"
                >
                  {{ $t('orderDetails.copy') }}
                </el-button>
                <div slot="reference">
                  {{ scope.row.nfeKey }}
                </div>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <!-- 推送方 -->
        <el-table-column :label="$t('tablePrice.pushParty')" min-width="160" prop="requestSource" />
        <!-- 推送方url -->
        <el-table-column :label="$t('tablePrice.pushPartyUrl')" min-width="160" prop="requestUrl" />
        <!-- 接收方 -->
        <el-table-column
          :label="$t('tablePrice.receiverParty')"
          min-width="160"
          prop="receiverName"
        />
        <!-- 接收方 -->
        <el-table-column
          :label="$t('tablePrice.receiverPartyUrl')"
          min-width="160"
          prop="receiverUrl"
        />
        <!-- 响应报文 -->
        <el-table-column
          :label="$t('orderCenterCont.ResponseMessages')"
          :show-overflow-tooltip="false"
          align="left"
          min-width="220"
          prop="responseParams"
        >
          <template slot-scope="scope">
            <el-tooltip placement="top">
              <pre slot="content" style="max-height: 400px; overflow: auto">
                  {{ scope.row.responseParams }}
                </pre>
              <div class="paramsStyle">{{ scope.row.responseParams }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!--推送报文-->
        <el-table-column
          :label="$t('tablePrice.pushMessage')"
          :show-overflow-tooltip="false"
          align="left"
          min-width="220"
          prop="originRequestParams"
        >
          <template slot-scope="scope">
            <el-tooltip placement="top">
              <pre slot="content" style="max-height: 400px; overflow: auto">
                  {{ scope.row.originRequestParams }}
                </pre>
              <div class="paramsStyle">{{ scope.row.originRequestParams }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!--是否下单成功-->
        <el-table-column
          :label="$t('tablePrice.orderSuccess')"
          :show-overflow-tooltip="true"
          align="center"
          min-width="140"
          prop="state"
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.state == 0" type="danger">
              {{ $t('operationCenter.fail') }}
            </el-tag>
            <el-tag v-if="scope.row.state == 1" type="success">
              {{ $t('operationCenter.succeed') }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          :current-page.sync="queryForm.pageNumber"
          :page-size.sync="queryForm.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 10px 0"
          @current-change="getCurrentTableData"
          @size-change="getSizeTableData"
        />
      </div>
    </el-card>
    <el-drawer
      :append-to-body="true"
      :close-on-click-modal="false"
      :title="$t('orderCenterCont.ViewDetails')"
      :visible.sync="drawerTag"
      custom-class="drawerClass"
      direction="ltr"
      size="70%"
    >
      <div class="preStyle">
        <el-form
          ref="updateForm"
          :model="updateForm"
          style="padding: 0 20px; height: calc(100vh - 68px); overflow-y: auto"
        >
          <el-row>
            <el-col :span="24">
              <div class="grid-content bg-purple">
                <!--订单号-->
                <el-form-item
                  :label="$t('orderCenterCont.TheOrderNumber') + '：'"
                  prop="orderNumber"
                >
                  <span>{{ updateForm.customerNumber }}</span>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">
                <!--客户-->
                <el-form-item :label="$t('operationCenter.client') + '：'" prop="customerName">
                  <span>{{ updateForm.customerName }}</span>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">
                <!--请求时间-->
                <el-form-item :label="$t('orderCenterCont.RequestTime') + '：'" prop="createTime">
                  <span>{{ updateForm.pushTime }}</span>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <div class="grid-content bg-purple-light">
                <!--推送报文-->
                <el-form-item label-width="0">
                  <div>
                    {{ $t('tablePrice.pushMessage') }}
                  </div>
                  <div class="messageCon">
                    <div
                      v-if="updateForm.originRequestParams"
                      style="text-align: right; line-height: 25px; padding: 5px"
                    >
                      <i
                        :title="$t('orderCenterCont.copy')"
                        class="el-icon-copy-document"
                        style="font-size: 20px; cursor: pointer"
                        @click="copy(updateForm.originRequestParams)"
                      />
                    </div>
                    <pre>{{ updateForm.originRequestParams }}</pre>
                  </div>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">
                <!--响应报文-->
                <el-form-item label-width="0">
                  <div>
                    {{ $t('orderCenterCont.ResponseMessages') }}
                  </div>
                  <div class="messageCon">
                    <div
                      v-if="updateForm.responseParams"
                      style="text-align: right; line-height: 25px; padding: 5px"
                    >
                      <i
                        :title="$t('orderCenterCont.copy')"
                        class="el-icon-copy-document"
                        style="font-size: 20px; cursor: pointer"
                        @click="copy(updateForm.responseParams)"
                      />
                    </div>
                    <pre>{{ updateForm.responseParams }}</pre>
                  </div>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <div class="grid-content bg-purple-light">
                <!--安骏下单报文-->
                <el-form-item label-width="0">
                  <div>
                    {{ $t('tablePrice.anJunOrderMessage') }}
                  </div>
                  <div class="messageCon">
                    <div
                      v-if="updateForm.requestParams"
                      style="text-align: right; line-height: 25px; padding: 5px"
                    >
                      <i
                        :title="$t('orderCenterCont.copy')"
                        class="el-icon-copy-document"
                        style="font-size: 20px; cursor: pointer"
                        @click="copy(updateForm.requestParams)"
                      />
                    </div>
                    <pre>{{ updateForm.requestParams }}</pre>
                  </div>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">
                <!-- 安骏下单响应报文 -->
                <el-form-item label-width="0">
                  <div>
                    {{ $t('tablePrice.anJunOrderResponseMessage') }}
                  </div>
                  <div class="messageCon">
                    <div
                      v-if="updateForm.originResponseParams"
                      style="text-align: right; line-height: 25px; padding: 5px"
                    >
                      <i
                        :title="$t('orderCenterCont.copy')"
                        class="el-icon-copy-document"
                        style="font-size: 20px; cursor: pointer"
                        @click="copy(updateForm.originResponseParams)"
                      />
                    </div>
                    <pre>{{ updateForm.originResponseParams }}</pre>
                  </div>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { copyData } from '@/utils/copyData';
import { customerPushOrderLogExport, customerPushOrderLogPage } from '@/api/orderApi';
import { apiCustomerPage } from '@/api/customer';
import dayjs from 'dayjs';
import { goResourceTaskList } from '@/utils/goExportList';

export default {
  name: 'CustomerOrderLog',
  data() {
    return {
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          state: null, // 是否下单成功: 0-失败, 1-成功
          customerId: null,
          inputValue: ''
        }
      },
      timeValue: [this.getAWeek().startDate + ' 00:00:00', this.getAWeek().endDate + ' 23:59:59'],
      selectType: 3,
      tableData: [],
      total: 0,
      drawerTag: false,
      updateForm: {},
      customerList: [] // 客户列表
    };
  },
  mounted() {
    this.getSearch();
  },
  methods: {
    // 公共：构建条件参数
    buildConditionParams() {
      // 时间校验
      if (this.timeValue?.length === 0) {
        this.$message.error(this.$t('GlobalSetObj.selectTime'));
        return null;
      }
      // 处理单号列表
      let inputValList = [];
      if (this.queryForm.params.inputValue) {
        // 按换行分割 + 去除首尾空格 + 过滤空项
        inputValList = this.queryForm.params.inputValue
          .split('\n')
          .map((item) => item.trim()) // 每行去掉首尾空格
          .filter((item) => item); // 过滤空字符串
      }
      if (inputValList.length > 2000) {
        this.$message.warning(this.$t('newOrder.searchMax1000'));
        inputValList = inputValList.slice(0, 2000);
      }
      // 构建条件参数
      const params = {
        startTime: this.timeValue[0],
        endTime: this.timeValue[1],
        customerId: this.queryForm.params.customerId,
        state: this.queryForm.params.state, // 是否成功
        customerNumber: [], // 客户单号
        waybillNumber: [], // 运单号
        scanOrderNumber: [], // 扫描单号
        nfeKey: [] // NFe密钥
      };
      if (this.selectType === 1) {
        params.waybillNumber = inputValList;
      } else if (this.selectType === 2) {
        params.scanOrderNumber = inputValList;
      } else if (this.selectType === 3) {
        params.customerNumber = inputValList;
      } else {
        params.nfeKey = inputValList;
      }
      return params;
    },
    // 获取订单日志
    getSearch() {
      const conditionParams = this.buildConditionParams();
      if (!conditionParams) return;
      const data = {
        pageNumber: this.queryForm.pageNumber,
        pageSize: this.queryForm.pageSize,
        params: conditionParams
      };
      customerPushOrderLogPage(data).then((res) => {
        if (res.code === 200) {
          this.total = res.data.total;
          this.tableData = res.data.records;
          this.tableData.map((item) => {
            if (item.requestParams) {
              try {
                item.requestParams = JSON.stringify(JSON.parse(item.requestParams), null, 2);
              } catch (e) {
                console.log(e, '===item.requestParams');
              }
            }
            if (item.responseParams) {
              try {
                item.responseParams = JSON.stringify(JSON.parse(item.responseParams), null, 2);
              } catch (e) {
                console.log(e, '===item.responseParams');
              }
            }
            if (item.originRequestParams) {
              try {
                item.originRequestParams = JSON.stringify(
                  JSON.parse(item.originRequestParams),
                  null,
                  2
                );
              } catch (e) {
                console.log(e, '===item.originRequestParams');
              }
            }
            if (item.originResponseParams) {
              try {
                item.originResponseParams = JSON.stringify(
                  JSON.parse(item.originResponseParams),
                  null,
                  2
                );
              } catch (e) {
                console.log(e, '===item.originResponseParams');
              }
            }
          });
        }
      });
    },
    // 导出
    allExportOrder() {
      const data = this.buildConditionParams();
      if (!data) return;
      customerPushOrderLogExport(data).then((res) => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    dateChange(val) {
      if (val === null) {
        this.timeValue = [];
        return;
      }
      if (this.timeValue[1]) {
        const endTime =
          dayjs(this.timeValue[0]).subtract(-1, 'month').format('YYYY-MM-DD') + ' 23:59:59';
        if (this.timeValue[1] > endTime) {
          this.$message({
            // '只允许查1个月内的数据'
            message: this.$t('collectionCenter.OnlyAllowedOneMonthsOfData'),
            type: 'warning'
          });
          this.timeValue = [
            this.getAWeek().startDate + ' 00:00:00',
            this.getAWeek().endDate + ' 23:59:59'
          ];
        }
      }
    },
    // 获取最近30天时间
    getAWeek() {
      // 默认最近30天时间
      return {
        endDate: dayjs().format('YYYY-MM-DD'),
        startDate: dayjs().subtract(30, 'day').format('YYYY-MM-DD')
      };
    },
    searchFun() {
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    // 搜索、重置
    searchResources(type) {
      this.queryForm.pageNumber = 1;
      if (type === 1) {
        this.getSearch();
      } else {
        this.selectType = 3;
        this.queryForm.params.inputValue = '';
        this.queryForm.params.customerId = '';
        this.queryForm.params.state = null;
        this.timeValue = [
          this.getAWeek().startDate + ' 00:00:00',
          this.getAWeek().endDate + ' 23:59:59'
        ];
        this.getSearch();
      }
    },
    // 查看详情
    operationBtn(row) {
      this.updateForm = row;
      this.drawerTag = true;
    },
    // 点击复制
    copy(data) {
      copyData(data);
    },
    // 页码变化翻页
    getCurrentTableData(val) {
      this.queryForm.pageNumber = val;
      this.getSearch();
    },
    // 每页显示数量变化
    getSizeTableData(val) {
      this.queryForm.pageSize = val;
      this.getSearch();
    },
    /**
     * @description 分页获取客户列表
     * @param { string } name 客户名称
     */
    getCustomerPage(name = '') {
      const param = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          quickSearch: name
        }
      };
      apiCustomerPage(param).then((res) => {
        if (res.code === 200) {
          this.customerList = res.data.records;
        }
      });
    }
  }
};
</script>
<style scoped>
.app-container >>> .drawerClass header {
  border-bottom: 1px solid #ccc;
  margin-bottom: 0;
  padding: 20px 20px 20px;
}

.app-container >>> .selectLabel .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
  border: none;
  font-weight: bold;
  text-align: left;
  padding: 0;
}

.app-container >>> .selectLabel .el-input__icon {
  line-height: 28px !important;
}

.preStyle {
  height: calc(100vh - 70px);
  overflow: hidden;
}

.preStyle .messageCon {
  background: #eee;
}

.preStyle pre {
  height: 500px;
  overflow-y: auto;
  white-space: break-spaces;
  margin: 0;
  padding: 0 10px;
  line-height: 26px;
}

.paramsStyle {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
